  <!-- TEST VAR VALs:
        <div>{{isShortenUrl}}</div>
        <div>Let's have the URL:{{shortenUrl}}</div>
    -->
<div class="bosch-bar" aria-hidden="true"></div>

<!-- User avatar dropdown (top-right, below the Bosch bar) -->
<div class="user-menu-wrapper" (document:click)="onDocumentClick($event)">
    <button class="user-avatar-btn" (click)="toggleMenu()" [class.open]="menuOpen" aria-label="User menu">
      <span class="avatar-initials">{{ username[0]?.toUpperCase() }}</span>
    </button>

    <div class="user-dropdown" *ngIf="menuOpen">
      <!-- Welcome header -->
      <div class="dropdown-header">
        <div class="dropdown-avatar">{{ username[0]?.toUpperCase() }}</div>
        <div class="dropdown-user-info">
          <span class="dropdown-welcome">Welcome</span>
          <span class="dropdown-username">{{ username }}</span>
        </div>
      </div>

      <div class="dropdown-divider"></div>

      <!-- Menu items -->
      <button class="dropdown-item disabled" disabled>
        <svg class="item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="10"/><path d="M12 8v4m0 4h.01"/>
        </svg>
        Language
        <span class="badge-soon">soon</span>
      </button>

      <button class="dropdown-item" (click)="goToProfile()">
        <svg class="item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/>
        </svg>
        Profile
      </button>

      <div class="dropdown-divider"></div>

      <button class="dropdown-item disabled" disabled>
        <svg class="item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/>
        </svg>
        Sign out
        <span class="badge-soon">soon</span>
      </button>
    </div>
  </div>

  <router-outlet></router-outlet>

<!-- Notifications Modal -->
<app-notifications-modal
  [isOpen]="showNotificationModal"
  [notifications]="unreadNotifications"
  (closeModal)="onNotificationModalClose()">
</app-notifications-modal>
